"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogContainer = void 0;
const React = require("react");
const dateFormat = require("dateformat");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const fluxible_router_1 = require("fluxible-router");
const BlogStore_1 = require("../stores/BlogStore");
const Entities_1 = require("../../backend/models/Entities");
const SideBar_1 = require("./SideBar");
const Slider_1 = require("./partials/Slider");
const Search_1 = require("./partials/Search");
const BlogActions_1 = require("../actions/BlogActions");
const helper_1 = require("../helper");
class Blog extends React.Component {
    constructor(props) {
        super(props);
        this.goToPost = (e, slug) => {
            e.preventDefault();
            this.props.executeAction(BlogActions_1.default.navigateToCurrentPost, { slug });
        };
    }
    render() {
        const postsResult = this.props.postsResult || new Entities_1.PagingResult();
        return (React.createElement("div", null,
            React.createElement(Slider_1.default, { posts: this.props.randoms }),
            React.createElement(Search_1.default, { executeAction: this.props.executeAction }),
            React.createElement("section", { className: 'blog-content blog-standard' },
                React.createElement("div", { className: 'container' },
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-md-9' },
                            React.createElement("div", { className: 'content' }, postsResult.results.map((post) => {
                                return (React.createElement("div", { key: post._id, className: 'post type-post status-publish format-image has-post-thumbnail hentry category-destinations tag-beach tag-croatia post_format-post-format-image' },
                                    (post.image && post.image.secure_url) ?
                                        React.createElement("div", { className: 'post-media' },
                                            React.createElement("div", { className: 'image-wrap' },
                                                React.createElement("img", { width: '900', height: '600', src: (0, helper_1.convertImageUrl)(post.image.secure_url), className: 'attachment-large size-large', alt: '', sizes: '(max-width: 900px) 100vw, 900px' })),
                                            React.createElement("div", { className: 'post-format' },
                                                React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug },
                                                    React.createElement("i", { className: 'fa fa-image' }))))
                                        : null,
                                    React.createElement("div", { className: 'post-body' },
                                        post.categories != null ?
                                            React.createElement("div", { className: 'post-cat' },
                                                React.createElement("ul", null, post.categories.map((category) => React.createElement("li", { key: category.key },
                                                    React.createElement(fluxible_router_1.NavLink, { href: '/blog?category=' + category.name }, category.name))))) : null,
                                        React.createElement("div", { className: 'post-title' },
                                            React.createElement("h2", null,
                                                React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug }, post.title))),
                                        React.createElement("div", { className: 'post-date' },
                                            React.createElement("span", null, dateFormat(post.publishedDate, 'mmmm dS, yyyy'))),
                                        React.createElement("div", { className: 'post-entry' },
                                            React.createElement("div", { dangerouslySetInnerHTML: { __html: post.textBrief } })),
                                        React.createElement("div", { className: 'post-link' },
                                            React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug }, "Continue reading...")))));
                            })),
                            (postsResult.previous || postsResult.next) ?
                                React.createElement("div", { className: 'pi-nav-page' },
                                    postsResult.previous ?
                                        React.createElement("li", { className: 'previous' },
                                            React.createElement(fluxible_router_1.NavLink, { href: '/blog?page=' + (this.props.page - 1) }, "\u2190 Newer")) : null,
                                    postsResult.next ?
                                        React.createElement("li", { className: 'next' },
                                            React.createElement(fluxible_router_1.NavLink, { href: '/blog?page=' + (this.props.page + 1) }, "Older \u2192")) : null) : null),
                        React.createElement(SideBar_1.default, null))))));
    }
}
class BlogContainer {
    constructor(request, result, randoms) {
        this.request = request;
        this.result = result;
        this.randoms = randoms;
    }
}
exports.BlogContainer = BlogContainer;
class BlogProps {
}
exports.default = (0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(Blog, [BlogStore_1.default], (context, props) => {
    return {
        postsResult: context.getStore(BlogStore_1.default).getPosts(),
        page: context.getStore(BlogStore_1.default).getPageNum(),
        request: context.getStore(BlogStore_1.default).getRequestData(),
        randoms: context.getStore(BlogStore_1.default).getRandoms(),
        executeAction: context.executeAction,
    };
}));
